import React, { PureComponent } from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';

export default class CustomAreaChart extends PureComponent {
  static jsfiddleUrl = 'https://jsfiddle.net/alidingling/Lrffmzfc/';

  render() {
    return (
      <AreaChart style={{ margin: '16px' }} width={this.props.width} height={130} data={this.props.data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey={this.props.x_label} />
        <YAxis domain={this.props.domain || ['auto', 'auto']} />
        <Tooltip />
        <Area type="monotone" dataKey={this.props.y_label} stroke="#8884d8" fill="#8884d8" />
      </AreaChart>
    );
  }
}
